import { handleActions } from 'redux-actions';
import { types } from './ipm-actions';

const {
  LOAD_IPM_CONTENT_SUCCESS,
  LOAD_IPM_CONTENT_FAIL,
  SET_IPM_CONTENT,
  CLEAR_IPM_CONTENT,
} = types;

export const initialState = {
  ipmContent: null,
  ipmContentLoaded: false,
};

export default handleActions(
  {
    [LOAD_IPM_CONTENT_SUCCESS]: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
    [LOAD_IPM_CONTENT_FAIL]: (state) => ({
      ...state,
      ipmContent: null,
      ipmContentLoaded: true,
    }),
    [SET_IPM_CONTENT]: (state, { payload }) => ({ ...state, ...payload }),
    [CLEAR_IPM_CONTENT]: (state) => ({
      ...state,
      ipmContent: null,
      ipmContentLoaded: false,
    }),
  },
  initialState,
);
